import React, { Component } from 'react'
import { ImageList, ImageListItem, ImageListItemBar, Checkbox } from '@mui/material'

const classes = {
  imageList: {
    width: '100%',
    height: 450,
    // backgroundColor: '#0f0',
    // borderWidth: 1,
    // borderColor: '#000',
    // borderStyle: 'solid',
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    // backgroundColor: '#f00',
  },
}

class ImageSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // selected: null,
      images: [],
    }
  }

  componentDidMount() {
    this.updateData()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.images !== this.props.images) {
      this.updateData()
    }
  }

  onSelect = (id) => {
    // this.setState({ selected: id })
    this.props.onSelect({ target: { value: id }})
  }

  updateData = () => {
    this.setState({ images: this.props.images })
  }

  // `multiple` and `selectedIds` are optional. Without them this behaves exactly as before,
  // which the single select callers (activities, news, event tickets) rely on - the
  // onSelect contract is unchanged either way.
  render() {
    const multiple = !!this.props.multiple
    const selectedIds = Array.isArray(this.props.selectedIds) ? this.props.selectedIds : []
    return (
      <div style={classes.root}>
        <ImageList rowHeight={120} style={classes.imageList} cols={3}>
          {this.state.images.map((item) => {
            if (typeof item.url !== 'string') return null
            const parts = item.url.split('/')
            const src =
              item.sizes && item.sizes.length > 1
                ? parts.slice(0, -1).join('/') + '/150_' + parts.slice(-1)
                : item.url
            const selected = selectedIds.indexOf(item.id) > -1
            return (
              <ImageListItem
                key={item.id}
                cols={item.cols || 1}
                onClick={() => this.onSelect(item.id)}
                sx={{
                  cursor: 'pointer',
                  ...(multiple && selected
                    ? { outline: '3px solid', outlineColor: 'primary.main', outlineOffset: '-3px' }
                    : {}),
                }}
              >
                <img src={src} alt={item.originalName} />
                {multiple ? (
                  <ImageListItemBar
                    position='top'
                    actionPosition='left'
                    sx={{ background: 'transparent' }}
                    actionIcon={
                      <Checkbox
                        checked={selected}
                        readOnly
                        disableRipple
                        // clicks must reach the tile so the toggle fires exactly once
                        sx={{ color: '#fff', pointerEvents: 'none' }}
                      />
                    }
                  />
                ) : null}
              </ImageListItem>
            )
          })}
        </ImageList>
      </div>
    )
  }
}

export default ImageSelector
